import React from "react";
import { Helmet } from 'react-helmet-async';
import RecentBlogPosts from "../components/Common/RecentBlogPosts";
import ServiceDetailsHeader from "../components/Common/ImageHeader";
import AllBlogPosts from "../components/CareersComponents/TeamActivityComponents/AllBlogPosts";
import { useNavigate, useLocation } from "react-router-dom";
import { useBlogs } from "../hooks/useBlog";

const Blog = () => {
  const { blogPosts, loading, error } = useBlogs();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get initial page from location state if user came back from blog details
  const initialPage = location.state?.initialPage || 1;

  const handleBreadcrumbClick = (href) => {
    if (href && href !== "#") {
      navigate(href);
    }
  };
  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Business Automation Systems Newsroom | Latest Updates & Press Releases</title>
        <meta 
          name="description" 
          content="Stay updated with the latest news, product launches, and press releases from Business Automation Systems. Discover our innovation and industry impact." 
        />
        <meta 
          name="keywords" 
          content="Business Automation Systems news, BA Systems press release, company updates, tech news Bangladesh, software industry news, BA Systems newsroom" 
        />
        <link rel="canonical" href="https://www.ba-systems.com/newsroom" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:url" content="https://ba-systems.com/newsroom" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Business Automation Systems Newsroom | Latest Updates & Press Releases" />
        <meta property="og:description" content="Stay updated with the latest news, product launches, and press releases from Business Automation Systems. Discover our innovation and industry impact." />
        <meta property="og:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="ba-systems.com" />
        <meta property="twitter:url" content="https://ba-systems.com/newsroom" />
        <meta name="twitter:title" content="Business Automation Systems Newsroom | Latest Updates & Press Releases" />
        <meta name="twitter:description" content="Stay updated with the latest news, product launches, and press releases from Business Automation Systems. Discover our innovation and industry impact." />
        <meta name="twitter:image" content="https://opengraph.b-cdn.net/production/images/e1930f8a-3aa2-4fe1-b6ea-0ad5030ebc97.png?token=vTkCXbq7qBnee_uxOFTj3-OKo7vP2KVzX66L6BYKzho&height=596&width=1200&expires=33297038875" />
      </Helmet>
      
      <ServiceDetailsHeader
        title="Newsroom"
        subtitle="Discover how our solutions have transformed organizations and delivered measurable results."
        backgroundImage="/png/newsroom_header.png"
        breadcrumbItems={[
          { label: "Home", href: "/" },
          { label: "Newsroom", href: "#", isCurrentPage: true },
        ]}
        onBreadcrumbClick={handleBreadcrumbClick}
      />
      <div
        style={{
          backgroundImage: "url(/png/background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <RecentBlogPosts
        blogPosts={blogPosts}
        title="Recent news posts"
        fromWhere="blog"
        showSeeMore={false}
        maxPosts={2}
        loading={loading}
        error={error}
      />
      <AllBlogPosts 
        blogPosts={blogPosts}
        loading={loading}
        error={error}
        skipCount={2}
        initialPage={initialPage}
      />
    </>
  );
};

export default Blog;
